import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class DpInterestDetailsUseCase extends BaseUseCase {
    constructor(DpInterestRepo) {
        super();
        this.DpInterestRepo = DpInterestRepo;
    }
    async fetchResult(req) {
        return await this.DpInterestRepo.getDpInterestDetails(req);
    }
}
export default DpInterestDetailsUseCase;
